import { EnvironmentOutlined } from "@ant-design/icons"
import { Menu, theme } from "antd"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
const { useToken } = theme

const PlacesDropdownRenderer = ({ predictions, onSelectPrediction, onEnterManual }) => {
  const { t } = useTranslation()
  const { token } = useToken()
  const hasPredictions = Array.isArray(predictions) && predictions.length > 0
  return (
    <Menu>
      {hasPredictions ? (
        predictions.map((prediction) => (
          <Menu.Item key={prediction.place_id} onClick={() => onSelectPrediction(prediction.place_id)}>
            <EnvironmentOutlined style={{ marginRight: 10, color: token.colorPrimary }} />
            {prediction.description}
          </Menu.Item>
        ))
      ) : (
        <Menu.Item disabled key="no-results">
          {t("listings.tabs.location.no_result_found")}
        </Menu.Item>
      )}

      <Menu.Divider />
      <Menu.Item key="manual" onClick={onEnterManual} style={{ color: token.colorPrimary }}>
        {t("listings.tabs.location.enter_manually")}
      </Menu.Item>
    </Menu>
  )
}

PlacesDropdownRenderer.propTypes = {
  predictions: PropTypes.array.isRequired,
  onSelectPrediction: PropTypes.func.isRequired,
  onEnterManual: PropTypes.func.isRequired
}

export default PlacesDropdownRenderer
